<template>
    <TableTemplate class="w-min-[600px] w-full h-full" :isLoading="waiting">
        <template v-slot:table-content>
            <thead
                class="divide-y bg-gray border-b-2 sticky top-0 select-none"
                ref="thead"
            >
                <tr>
                    <th class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer">
                        <div class="cursor-pointer flex items-center gap-4 h-full">
                            <p>Дата народження</p>
                        </div>
                    </th>
                    <th class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer">
                        <div class="cursor-pointer flex items-center gap-4 h-full">
                            <p>Номер телефону</p>
                        </div>
                    </th>
                    <th class="p-3 text-sm font-semibold tracking-wide text-left cursor-pointer">
                        <div class="cursor-pointer flex items-center gap-4 h-full">
                            <p>Клієнт</p>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100" ref="tbody">
                <tr
                    v-for="client in birthdays"
                    :key="client.id"
                    class="hover:bg-blue-200 cursor-pointer h-12 select-none"
                    :class="{ 'bg-green-200': isToday(client.birthday), 'hover:bg-blue-200': !isToday(client.birthday) }"
                >
                    <td class="text-left flex items-center p-3">{{ new Date(client.birthday).toLocaleDateString('uk') }}</td>
                    <td class="text-left items-center p-3">{{ client.phonenum }}</td>
                    <td class="text-left items-center p-3">{{ client.name + " " + client.surname }}</td>
                </tr>
            </tbody>
        </template>
        <template v-slot:pagination>
            <Pagination
                v-if="pageLength > 1"
                v-model="currentPage"
                :current-page="currentPage"
                :pages="pageLength"
                @update:modelValue="setCurrentPage"
            />
        </template>
    </TableTemplate>
</template>


<script>
import TableTemplate from '../../reusable/TableTemplate.vue';
import Pagination from '../../reusable/Pagination.vue';
export default {
    name: "ClientBirthdays",
    components: {
        TableTemplate,
        Pagination
    },
    data: function () {
        return {
            birthdays: [],
            waiting: false,
            totalRecords: 0,
            currentPage: 1,
            limit: 13
        }
    },
    methods: {
        async getClientBirthdays(params) {
            try {
                const res = await this.$api.clients.getBirthdays(params);
                this.birthdays = res.data.clients;
                this.totalRecords = res.data.total_records;
            } catch (error) {
                console.log(error);
            }
        },
        async setCurrentPage(page) {
            this.currentPage = page;
            this.getClientBirthdays({
                page: page,
                limit: this.limit
            });
        },
        isToday(date) {
            const today = new Date();
            const birthday = new Date(date);

            return (
                today.getDate() === birthday.getDate() &&
                today.getMonth() === birthday.getMonth()
            )
        }
    },
    computed: {
        pageLength() {
            return Math.ceil(this.totalRecords / 10);
        }
    },
    async mounted() {
        this.getClientBirthdays({
            page: this.currentPage,
            limit: this.limit
        });
    }
}
</script>